import React from 'react';
import classnames from 'classnames';
import Service from '@superdata/basic-data-service';
import styles from './index.module.less';

const Copyright = (props: any) => {
  const { config } = window.Service ?? Service;
  const sys_company_logo: string = config.getField('sys_company_logo') as string;
  const sys_version: string = config.getField('sys_version') as string;
  const sys_copyright: string = config.getField('sys_copyright') as string;
  return (
    // <img src={`/${SystemConfig.sys_small_logo}`} alt="" className={props.className} />
    <div className={classnames(styles.copyright, props.className)}>
      <img src={sys_company_logo} alt="" className={styles.img} />
      <div className={styles.tips}>建议使用谷歌浏览器最新版，在分辨率为1920×1080的显示器上显示使用体验最佳</div>
      <div>{`${sys_version || 'Copyright 2016-2022'}${sys_copyright || '武汉数矿科技有限公司'}`}</div>
    </div>
  )
};

export default Copyright;
